 import { useContext } from "react";
 import { Checkbox, FormControlLabel } from "@material-ui/core";
import { BundleFormModalContext } from "../modals/BundleFormModalContext";

 export const DraftToggle = () => {
   const { modelData, updateModelData } = useContext(BundleFormModalContext);

   return (
     <FormControlLabel
       label="Чернетка"
       control={
         <Checkbox
           checked={modelData.isDraft ?? false}
           onChange={({ target: { checked } }) => updateModelData("isDraft", checked)}       
           color="default"
         />
       }
     />
   );
 };
